import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import Council from "../pages/Council";
import Events from "../pages/Events";
import EventsDetails from "../pages/EventsDetails";
import NewsLetter from "../pages/NewsLetter";
import BecomeMember from "../pages/BecomeMember";
import BenefitsMember from "../pages/BenefitsMember";
import ListMember from "../pages/ListMember";
import Contact from "../pages/Contact";
import Archive from "../pages/Archive";
import FacialPlasticSurgery from "../pages/surgical_domains/FacialPlasticSurgery";
import FacialPlasticSurgeons from "../pages/surgical_domains/FacialPlasticSurgeons";
import Rhinoplasty from "../pages/surgical_domains/Rhinoplasty";
import LowerBlepharoplasty from "../pages/surgical_domains/LowerBlepharoplasty";
import UpperBlepharoplasty from "../pages/surgical_domains/UpperBlepharoplasty";
import FaceLift from "../pages/surgical_domains/FaceLift";
import ForeHeadLift from "../pages/surgical_domains/ForeHeadLift";
import Mentoplasty from "../pages/surgical_domains/Mentoplasty";
import Otoplasty from "../pages/surgical_domains/Otoplasty";
import ScarRevision from "../pages/surgical_domains/ScarRevision";
import SkinCancer from "../pages/surgical_domains/SkinCancer";
import SkinPeels from "../pages/surgical_domains/SkinPeels";
import BotulinumToxin from "../pages/surgical_domains/BotulinumToxin";
import FatGrafting from "../pages/surgical_domains/FatGrafting";
import Gallery from "../pages/Gallery";
import GalleryView from "../pages/GalleryView";
import Login from "../pages/Login";
import CallBackHandler from "../pages/CallBackHandler";
import FellowShip from "../pages/FellowShip";
import Observership from "../pages/Observership";
import ErrorPage from "../pages/ErrorPage";
import AdminDashboard from "../pages/user/AdminDashboard";
import MemberDashboard from "../pages/user/MemberDashboard";
import AdminMembers from "../pages/user/AdminMembers";
import AdminAffiliateRegistration from "../pages/user/AdminAffiliateRegistration";
import MemberProfile from "../pages/user/MemberProfile";
import EditMember from "../components/user/admin/EditMember";

const Main = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/council" element={<Council />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/events-details" element={<EventsDetails />} />
        <Route path="/news-letter" element={<NewsLetter />} />
        <Route path="/become-a-member" element={<BecomeMember />} />
        <Route path="/benefits-of-member" element={<BenefitsMember />} />
        <Route path="/list-of-all-member" element={<ListMember />} />
        <Route
          path="/types-of-facial-plastic-surgery"
          element={<FacialPlasticSurgery />}
        />
        <Route
          path="/who-is-a-facial-plastic-surgeon"
          element={<FacialPlasticSurgeons />}
        />
        <Route path="/rhinoplasty" element={<Rhinoplasty />} />
        <Route path="/lower-blepharoplasty" element={<LowerBlepharoplasty />} />
        <Route path="/upper-blepharoplasty" element={<UpperBlepharoplasty />} />
        <Route path="/face-lift" element={<FaceLift />} />
        <Route path="/fore-head-lift" element={<ForeHeadLift />} />
        <Route path="/mentoplasty" element={<Mentoplasty />} />
        <Route path="/otoplasty" element={<Otoplasty />} />
        <Route path="/scar-revision" element={<ScarRevision />} />
        <Route path="/skin-cancer" element={<SkinCancer />} />
        <Route path="/skin-peels" element={<SkinPeels />} />
        <Route path="/botulinum-toxin" element={<BotulinumToxin />} />
        <Route path="/fat-grafting" element={<FatGrafting />} />
        <Route path="/fellowship" element={<FellowShip />} />
        <Route path="/observership" element={<Observership />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/gallery-view" element={<GalleryView />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<CallBackHandler />} />
        <Route path="*" element={<ErrorPage />} />

        {/* Admin */}
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/members" element={<AdminMembers />} />
        <Route path="/admin/affliliates" element={<AdminAffiliateRegistration />} />
        <Route path="/admin/members/edit" element={<EditMember />} />
        {/*  */}
        {/* Member */}
        <Route path="/member/dashboard" element={<MemberDashboard />} />
        <Route path="/member/profile" element={<MemberProfile />} />
        {/*  */}
      </Routes>
    </>
  );
};

export default Main;
